import axios from "axios";
import { useAuth } from "../context/AuthContext"; // Importa o contexto de autenticação, se necessário
import { apiBase } from "../utils/server/api"; // Importa a base da URL da API

// Define o tipo de uma solicitação de relatório
export interface EngineerReportRequest {
    id: number;
    engineer_id: number;
    property_id: number;
    status: string;
    city: string;
    updated_at: string;
    property: {
        id: number;
        name: string;
        city: string;
        federal_unity: string;
        // Adicione outros campos conforme necessário
    };
}

// Função para obter solicitações de relatório
const getEngineerReportRequests =
    (config: ReturnType<typeof useAuth>["axiosConfig"]) => async (): Promise<EngineerReportRequest[]> => {
        try {
            const response = await axios.get(`${apiBase}/user/engineer-report-requests`, config());
            return response.data as EngineerReportRequest[];
        } catch (error) {
            console.error("Falha ao buscar solicitações de relatório:", error);
            throw error;
        }
    };

    const updateEngineerReportRequest = (
        config: ReturnType<typeof useAuth>["axiosConfig"]
    ) => async (id: number, status: 'accepted' | 'denied') => {
        try {
            await axios.post(`${apiBase}/user/engineer-report-requests/${id}`, {
                status: status // O status a ser atualizado
            }, config());
        } catch (error) {
            console.error("Falha ao atualizar o status da solicitação:", error);
            throw error;
        }
    };
    
    // Exporta ambas as funções
    export { getEngineerReportRequests, updateEngineerReportRequest };
